import { GearIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Flex, Typography } from "antd";
import { TrackedFatButton } from "components/FatButton/FatButton";
import { useAntTheme } from "hooks/useAntTheme";
import React from "react";
import { useNavigate } from "react-router-dom";

interface ProjectSettingsNotApprovedProps {
  projectId: string;
  storyboardId: string;
}

export const ProjectSettingsNotApproved: React.FC<
  ProjectSettingsNotApprovedProps
> = ({ projectId, storyboardId }) => {
  const t = useTranslate();
  const navigate = useNavigate();
  const { theme } = useAntTheme();

  return (
    <Flex vertical align="center">
      <Typography.Text
        style={{
          fontSize: 36,
          fontFamily: "Montserrat, sans-serif",
          marginTop: 0,
          marginBottom: 16,
        }}
      >
        {t("media.projects.detail.toDoNext")}
      </Typography.Text>
      <TrackedFatButton
        type={"default"}
        titleFontSize={20}
        contentFontSize={12}
        title={t("projects.components.ProgressHelp.approveSettings")}
        icon={<GearIcon size={45} />}
        iconSize={55}
        iconColor={theme.colorPrimary}
        style={{
          width: "100%",
          flex: "1",
          maxWidth: "275px",
          minHeight: "140px",
        }}
        onClick={() => {
          navigate(`/media/projects/${projectId}/${storyboardId}/setup`);
        }}
      />
    </Flex>
  );
};
